export enum EActionTypes {
  GET_DATE_FORMAT = 'GET_DATE_FORMAT',
}
